// @ts-expect-error
import type {HistoryAction} from 'react-router-dom';

// As documented here: https://reactrouter.com/core/api/Prompt, a function in the message
// that returns a string will prompt before allowing the transition.
// This function provides the string for the Prompt message function, if needed.
export const getRouteChangeBlockingMessage = (action: HistoryAction) => {
    const timelineCreator = $('div.timeline-creator');
    if (
        // We can see PUSH and REPLACE actions, we don't care about REPLACE actions.
        action === 'PUSH' &&
        timelineCreator.length &&
        Timeline.getInputValue(timelineCreator).length
    ) {
        return 'You have an unsaved timeline entry that will be lost if you leave or reload this page.';
    }

    return null;
};
